function byPosition({ position: posA }, { position: posB }) {
  return posA - posB;
}

/**
 * Reducer to make property grouping based on entity id of the associatedProperty,
 * keeping the position in group and items
 * @param acc accumulator
 * @param record of { data, associatedProperty, position }
 * @param index
 */
function groupReducer(acc, record, index) {
  const { data, position, recordId, confidentiality, ...rest } = record;
  let { associatedProperty = {} } = record;
  let { entity } = associatedProperty;

  if (!entity) {
    // NOTE: this block adds a custom property
    entity = { id: index * -1 };
    associatedProperty = { entity };
  }

  const { id } = entity;
  const existingValue = acc[id];
  if (!!existingValue) {
    const sortedData = [...existingValue.data, { ...data, position, recordId, confidentiality }].sort(byPosition);
    return { ...acc, [id]: { ...existingValue, data: sortedData } };
  }
  return {
    ...acc,
    [id]: { ...rest, associatedProperty, data: [{ ...data, position, recordId, confidentiality }], position },
  };
}

/**
 * To group records by property id, keep the position by item and grouped record
 * @params records array of { data, associatedProperty, position }
 * */
export function groupByProperty(records) {
  const groupedRecords = records.reduce(groupReducer, {});
  return Object.values(groupedRecords).sort(byPosition);
}

/**
 * Map every single record as { header, data[] } and keep the position to the parent
 * @param record (item with data, position and associatedProperty or full property information)
 * */
export function toCondensedSection({ data, position, ...rest }) {
  return {
    ...rest,
    data: [{ ...data, position }],
    position,
  };
}

export function sortByParentPosition(records) {
  return records.map(toCondensedSection).sort(byPosition);
}
